//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from '@/views/stencil/components/title'
import BScroll from 'better-scroll'
import { InsurStore } from '../../store'
import  ClinicToast  from '@/components/common/clinicToast'


    export default {
        name:'mechanism',
        data() {
            return {
                // key: value
                bs :null,
                dataList : [],
                modeShow:false,
                hostPonit:{  //机构定位
                    lat: '',
                    lng: ''
                }
            }
        },
        components: {
            InTitle,
            ClinicToast
        },
        mounted() {
            this.init()
        },
        computed: {
            insurance() {
                return InsurStore.insurance || {}
            },
            institutionList() {
                return Array.isArray(this.insurance.institutionList) ? this.insurance.institutionList : []
            },
        },
        watch: {
            institutionList(newValue, oldValue) {
                this.dataList = newValue
                this.init()
            }
        },
        created(){
            this.dataList = this.institutionList
        },
        methods: {
            // 初始化BScroll
            init() {
                if(this.$refs.scroll){
                    this.bs = new BScroll(this.$refs.scroll, {
                        startX: 0,
                        click: true,
                        scrollX: true,
                        scrollY: false,
                        eventPassthrough: "vertical"
                    })
                }
                
            },
            mapClick(item){
                this.STATISTICS_CONFIG.insur_proinfo_clinic_click()
                if(item.latitude && item.longitude){
                    this.hostPonit = {
                        lat: item.latitude,
                        lng: item.longitude
                    }
                    this.$nextTick(()=>{
                        this.modeShow=true;
                    })
                }else{
                    this.$toast('机构坐标缺失')
                }
                
            },
            moreClick(){
                this.hostPonit = {}
                this.modeShow = true;
                this.STATISTICS_CONFIG.insur_proinfo_allclinic_click()
            }
        }
    }
